/**
 * German Regions and Service Type Constants
 * Used for service area preferences in substitute profiles
 */

export const FEDERAL_STATES = [
  { code: 'BW', name: 'Baden-Württemberg' },
  { code: 'BY', name: 'Bayern' },
  { code: 'BE', name: 'Berlin' },
  { code: 'BB', name: 'Brandenburg' },
  { code: 'HB', name: 'Bremen' },
  { code: 'HH', name: 'Hamburg' },
  { code: 'HE', name: 'Hessen' },
  { code: 'MV', name: 'Mecklenburg-Vorpommern' },
  { code: 'NI', name: 'Niedersachsen' },
  { code: 'NW', name: 'Nordrhein-Westfalen' },
  { code: 'RP', name: 'Rheinland-Pfalz' },
  { code: 'SL', name: 'Saarland' },
  { code: 'SN', name: 'Sachsen' },
  { code: 'ST', name: 'Sachsen-Anhalt' },
  { code: 'SH', name: 'Schleswig-Holstein' },
  { code: 'TH', name: 'Thüringen' },
] as const;

/**
 * 17 KV Regions in Germany
 * Note: Nordrhein-Westfalen has 2 separate KV organizations
 */
export const KV_REGIONS = [
  'KV Baden-Württemberg',
  'KV Bayern',
  'KV Berlin',
  'KV Brandenburg',
  'KV Bremen',
  'KV Hamburg',
  'KV Hessen',
  'KV Mecklenburg-Vorpommern',
  'KV Niedersachsen',
  'KV Nordrhein',
  'KV Westfalen-Lippe',
  'KV Rheinland-Pfalz',
  'KV Saarland',
  'KV Sachsen',
  'KV Sachsen-Anhalt',
  'KV Schleswig-Holstein',
  'KV Thüringen',
] as const;

/**
 * Mapping of federal state codes to their KV regions
 * Note: Nordrhein-Westfalen (NW) has 2 separate KV organizations
 */
export const KV_REGIONS_BY_STATE: Record<FederalStateCode, readonly string[]> = {
  BW: ['KV Baden-Württemberg'],
  BY: ['KV Bayern'],
  BE: ['KV Berlin'],
  BB: ['KV Brandenburg'],
  HB: ['KV Bremen'],
  HH: ['KV Hamburg'],
  HE: ['KV Hessen'],
  MV: ['KV Mecklenburg-Vorpommern'],
  NI: ['KV Niedersachsen'],
  NW: ['KV Nordrhein', 'KV Westfalen-Lippe'],
  RP: ['KV Rheinland-Pfalz'],
  SL: ['KV Saarland'],
  SN: ['KV Sachsen'],
  ST: ['KV Sachsen-Anhalt'],
  SH: ['KV Schleswig-Holstein'],
  TH: ['KV Thüringen'],
};

/**
 * Service types for medical duties
 */
export const SERVICE_TYPES = [
  {
    value: 'fahrdienst' as const,
    label: 'Hausbesuchsdienst',
    icon: 'Car' as const,
    description: 'Hausbesuchsdienst (Fahrdienst) - Home visits in the service area',
  },
  {
    value: 'sitzdienst' as const,
    label: 'Sitzdienst',
    icon: 'Building' as const,
    description: 'Clinic-based duty (practice location)',
  },
  {
    value: 'kombidienst' as const,
    label: 'Kombidienst',
    icon: 'Phone' as const,
    description: 'Consultation services (phone-based)',
  },
  {
    value: 'hintergrunddienst' as const,
    label: 'Hintergrunddienst',
    icon: 'Shield' as const,
    description: 'Background duty (on-call availability)',
  },
] as const;

export type ServiceTypeValue = (typeof SERVICE_TYPES)[number]['value'];
export type FederalStateCode = (typeof FEDERAL_STATES)[number]['code'];
export type FederalStateName = (typeof FEDERAL_STATES)[number]['name'];
export type KVRegion = (typeof KV_REGIONS)[number];
